import {
	Close as CancelIcon,
	DeleteOutlined as DeleteIcon,
	Edit as EditIcon,
	Save as SaveIcon,
} from '@mui/icons-material';
import { GridActionsCellItem, GridColDef, GridEditInputCell, GridRowId, GridRowModes } from '@mui/x-data-grid-pro';
import React from 'react';

const SubscriptionInvoiceEmailColumns = ({ editable, subscriptionInvoiceEmailActions }): GridColDef[] => [
	{
		field: 'actions',
		type: 'actions',
		headerName: 'Actions',
		flex: 1,
		cellClassName: 'actions',
		getActions: subscriptionInvoiceEmailActions,
	},
	{
		field: 'email',
		editable,
		flex: 1,
		headerName: 'Recipients',
		renderEditCell: (params) => (
			<GridEditInputCell {...params} inputProps={{ 'data-cy': 'edit-recipients-input' }} />
		),
	},
];

const SubscriptionInvoiceEmailActions = ({
	rowModesModel,
	rows,
	setRows,
	setRowModesModel,
	isEditingAllowed = true,
}) => {
	const handleEditClick = (id: GridRowId) => () => {
		setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
	};

	const handleSaveClick = (id: GridRowId) => () => {
		setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
	};

	const handleDeleteClick = (id: GridRowId) => () => {
		setRows(rows.filter((row) => row.id !== id));
	};

	const handleCancelClick = (id: GridRowId) => () => {
		// if the id is a number when cancelled, it's a new row. we
		// need to filter out said row as it was never saved.
		if (typeof id === 'number') {
			setRows(rows.filter((row) => row.id !== id));
		}

		setRowModesModel({
			...rowModesModel,
			[id]: { mode: GridRowModes.View, ignoreModifications: true },
		});
	};

	const renderActions = ({ id }) => {
		if (rowModesModel[id]?.mode === GridRowModes.Edit) {
			return [
				<GridActionsCellItem
					icon={<SaveIcon />}
					label='Save'
					key='save'
					onClick={handleSaveClick(id)}
					onResize={() => {}}
					onResizeCapture={() => {}}
					showInMenu={false}
					data-cy='save-row-button'
				/>,
				<GridActionsCellItem
					icon={<CancelIcon />}
					label='Cancel'
					key='cancel'
					className='textPrimary'
					onClick={handleCancelClick(id)}
					color='inherit'
					onResize={() => {}}
					onResizeCapture={() => {}}
					showInMenu={false}
					data-cy='cancel-row-button'
				/>,
			];
		}
		if (isEditingAllowed) {
			// if the current row isn't being edited but we allow
			// rows to be edited, return the below options
			return [
				<GridActionsCellItem
					onResize={() => {}}
					onResizeCapture={() => {}}
					showInMenu={false}
					icon={<EditIcon />}
					label='Edit'
					key='edit'
					className='textPrimary'
					onClick={handleEditClick(id)}
					color='inherit'
					data-cy='edit-row-button'
				/>,
				<GridActionsCellItem
					icon={<DeleteIcon />}
					label='Delete'
					key='delete'
					onClick={handleDeleteClick(id)}
					color='inherit'
					onResize={() => {}}
					onResizeCapture={() => {}}
					showInMenu={false}
					data-cy='delete-row-button'
				/>,
			];
		}
		return [];
	};

	return renderActions;
};

export { SubscriptionInvoiceEmailActions, SubscriptionInvoiceEmailColumns };
